var map = {
	"./IndustriesWeServe": 232,
	"./IndustriesWeServe.jsx": 232,
	"./banking-finance-insurance": 511,
	"./banking-finance-insurance.js": 511,
	"./ecommerce-retail-b2b": 512,
	"./ecommerce-retail-b2b.js": 512,
	"./education-elearning": 513,
	"./education-elearning.js": 513,
	"./event-tickets": 514,
	"./event-tickets.js": 514,
	"./food-restaurant": 515,
	"./food-restaurant.js": 515,
	"./gaming-leisure": 516,
	"./gaming-leisure.js": 516,
	"./healthcare-fitness": 517,
	"./healthcare-fitness.js": 517,
	"./industriesSectionData": 46,
	"./industriesSectionData.js": 46,
	"./media-entertainment": 518,
	"./media-entertainment.js": 518,
	"./real-estate-property": 519,
	"./real-estate-property.js": 519,
	"./servicesOffered": 233,
	"./servicesOffered.js": 233,
	"./social-networking": 520,
	"./social-networking.js": 520,
	"./transport-automotive": 521,
	"./transport-automotive.js": 521,
	"./travel-hospitality": 522,
	"./travel-hospitality.js": 522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 231;